var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.707 0.292786C5.51947 0.105315 5.26516 -9.38469e-07 5 -9.61651e-07C4.73484 -9.84832e-07 4.48053 0.105315 4.293 0.292786L0.292999 4.29279C0.105528 4.48031 0.000213405 4.73462 0.000213392 4.99979C0.00021338 5.26495 0.105528 5.51926 0.292999 5.70679L4.293 9.70679C4.4816 9.88894 4.7342 9.98974 4.9964 9.98746C5.2586 9.98518 5.50941 9.88001 5.69482 9.6946C5.88023 9.5092 5.9854 9.25838 5.98767 8.99619C5.98995 8.73399 5.88916 8.48139 5.707 8.29279L3.414 5.99979L15 5.99979C15.2652 5.99979 15.5196 5.89443 15.7071 5.70689C15.8946 5.51936 16 5.265 16 4.99979C16 4.73457 15.8946 4.48022 15.7071 4.29268C15.5196 4.10514 15.2652 3.99979 15 3.99979L3.414 3.99979L5.707 1.70679C5.89447 1.51926 5.99979 1.26495 5.99979 0.999786C5.99979 0.734621 5.89447 0.480313 5.707 0.292786Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/receive.1aaf3777259eca9554f7023c95dda04a.svg";
export { ForwardRef as ReactComponent };